import {Grid, MenuItem, Select, Typography} from "@mui/material";
import React from "react";
import {useWelcomeAssistantContext} from "../ContextType";
import {MoneyRange} from "../Types/MoneyRange";
import {MoneyItemSelect} from "../MoneyItemSelect";
import {Slider} from "../Slider";
import {FooterButtons} from "../FooterButtons";
import {Label} from "../Label";


const equityCapitalChoices: MoneyRange[] = [
    {from: 0, to: 10000, label: 'Weniger als 10.000 €', isMinimum: true},
    {from: 10000, to: 25000, label: '10.000 € - 25.000 €', isMinimum: false},
    {from: 25000, to: null, label: 'über 25.000 €', isMinimum: false},
];

const monthlyInvestChoices: MoneyRange[] = [
    {from: 0, to: 200, label: 'Weniger als 200 €', isMinimum: true},
    {from: 200, to: 300, label: '200 € - 400 €', isMinimum: false},
    {from: 400, to: null, label: 'über 400 €', isMinimum: false},
];

export function Stage1() {
    const {equityCapitalState, setEquityCapitalState, monthlyInvestState, setMonthlyInvestState,
    type, source, setSource} = useWelcomeAssistantContext();

    const isValid = () => {

        if (type === 'intern' && !source) {
            return false;
        }

        return equityCapitalState != undefined && monthlyInvestState != undefined;
    }

    return (
        <Slider nr={1}>
            <Grid container rowGap={3} justifyContent="center">
                <Grid item xs={12}  pt={1}>
                    <Label>Wie viel Eigenkapital willst du investieren?</Label>
                    <MoneyItemSelect selectOptions={equityCapitalChoices} value={equityCapitalState}
                                     onChange={(value => setEquityCapitalState(value))}/>
                </Grid>
                <Grid item xs={12} pt={1}>
                    <Label>Wie viel wärst du bereit monatlich für deinen Vermögensaufbau zu investieren?</Label>
                    <MoneyItemSelect selectOptions={monthlyInvestChoices} value={monthlyInvestState}
                                     onChange={(value => setMonthlyInvestState(value))}/>
                </Grid>

                {type === 'intern' && <Grid item xs={12} pt={1}>
                    <Label>Leadquelle</Label>

                    <Select variant={"standard"}  value={source}
                            onChange={e => setSource(e.target.value)}>
                        <MenuItem value={'Instagram'}>Instagram</MenuItem>
                        <MenuItem value={'TikTok'}>TikTok</MenuItem>
                        <MenuItem value={'Facebook'}>Facebook</MenuItem>
                        <MenuItem value={'Google'}>Google</MenuItem>
                        <MenuItem value={'LinkedIn'}>LinkedIn</MenuItem>
                    </Select>

                    </Grid>
                }

                <Grid item xs={12}>
                    <FooterButtons forwardEnabled={isValid()} backVisible={false} increaseStepNumber={true}/>
                </Grid>
            </Grid>
        </Slider>
    );
}